import { IDB_DATA_COLLECTIONS_STORE, IDB_INDEX_TEMPLATE_ID } from '../constants/idb.config';

export function migrationFactory(): { [key: number]: (db: IDBDatabase, transaction: IDBTransaction) => void } {
    return {
        // 1: (db, transaction): void => {
        //     // const storeDataCollections = transaction.objectStore(IDB_DATA_COLLECTIONS_STORE);
        //     // const storeDataCollectionTemplates = transaction.objectStore(IDB_DATA_COLLECTION_TEMPLATES_STORE);
        // },
        2: (db, transaction): void => {
            const store = transaction.objectStore(IDB_DATA_COLLECTIONS_STORE);

            store.createIndex(IDB_INDEX_TEMPLATE_ID, IDB_INDEX_TEMPLATE_ID, { unique: false });
        },
    };
}
